/* Tile Touch — range colour + size swatches (metafield-driven, runtime).
   Fetches product Colour/Size metafields via /collections/all-tiles?view=rangedata,
   groups sister products by SERIES (first title word + prefix-merge), and renders:
     - COLOUR chips (hex, with a product-image dot fallback for un-nameable colours)
       for ranges that vary by colour (most ranges)
     - SIZE chips for ranges that vary by size/format (e.g. Arkiquartz, Burton)
   Cached in localStorage (12h) so it's effectively instant after first load. */
(function () {
  'use strict';
  var DATA_URL = '/collections/all-tiles?view=rangedata';
  var CACHE_KEY = 'tt_range_v11';
  var TTL = 12 * 3600 * 1000;

  var HEX = {
    white:'#F1EEE8', ivory:'#F3ECDD', cream:'#EFE7D6', beige:'#E3D5C1', sand:'#E1D3BB',
    green:'#7E8B6D', sage:'#9AA88C', aqua:'#A9C4CB', blue:'#8FB0C4', teal:'#4E8C8C',
    mustard:'#DCA842', yellow:'#DCA842', terracotta:'#A9573A', red:'#B23B2E', burgundy:'#5E2A28',
    pink:'#D8B4A6', blush:'#D8B4A6', rose:'#D8A7A0', brown:'#8A6A50', bronze:'#A9773F',
    grey:'#9A958C', gray:'#9A958C', charcoal:'#3A3632', black:'#2C2723', amber:'#C8912B',
    gold:'#C9A24B', orange:'#D98A3D', coral:'#E08A6E', silver:'#C3C3C1', smoke:'#8E8B87',
    rust:'#B45A38', saffron:'#E0A83C', navy:'#2E3D52', olive:'#7A7A4E', tan:'#C9A97E',
    mint:'#BFE0C8', jade:'#5FA080', oribe:'#5C6B4F', avio:'#6E8CA0', natural:'#E4D8C4',
    pearl:'#EDE8DF', mocha:'#8A6A55', taupe:'#B3A395', graphite:'#4A4A4A', ochre:'#C98A3B',
    wheat:'#D8C08A', espresso:'#4B342A', mahogany:'#7B4A38', walnut:'#6B4A32', slate:'#5A6470',
    army:'#6B7B4E', forest:'#41533A', emerald:'#2E7D5B', khaki:'#8F8B5E', lime:'#A6C34C',
    clay:'#B87A56', honey:'#D9A441', caramel:'#B5793F', oak:'#C2A57B', stone:'#CFC6B8',
    ash:'#B7B2A8', bone:'#E7DFD0', linen:'#E6DECF', cotto:'#B5623C', titanium:'#9AA0A6',
    ecru:'#E6DCC7', greige:'#C9BEAD', rosa:'#D8A7A0', avorio:'#EFE4CE', oribe:'#5C6B4F'
  };
  function hexOf(name) {
    name = String(name == null ? '' : name);
    if (!name) return null;
    var w = name.toLowerCase().split(/[^a-z]+/).filter(Boolean);
    for (var i = 0; i < w.length; i++) { if (HEX[w[i]]) return HEX[w[i]]; } // first known colour word (most specific descriptor)
    return null;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function purl(h) { return '/products/' + h; }
  function thumb(src, w) { return src ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : ''; }
  function uniqueBy(arr, k) { var s = {}, o = []; arr.forEach(function (x) { if (x[k] && !s[x[k]]) { s[x[k]] = 1; o.push(x); } }); return o; }
  function seriesKey(title) { return (String(title || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean)[0]) || 'x'; }
  // Colour/Size metafields are LIST types, so their .value is an array. Normalise to a string.
  function firstVal(v) { if (Array.isArray(v)) { for (var i = 0; i < v.length; i++) { var s = String(v[i]).trim(); if (s) return s; } return ''; } return v == null ? '' : String(v).trim(); }
  function joinVal(v) { if (Array.isArray(v)) return v.map(function (x) { return String(x).trim(); }).filter(Boolean).join(' / '); return v == null ? '' : String(v).trim(); }

  // Words in a title that are NOT part of the colour (the series/first word is dropped separately).
  var STOP = {};
  ('kazoku japanese italian spanish european porcelain ceramic tile tiles mosaic mosaics hand crafted handcrafted glazed unglazed full body look brick square rectangle long kit kat kitkat penny round pennyround hexagon hex subway zellige terrazzo matt matte gloss satin polished honed textured mini border sheet sheets wall floor deco decor feature natural finish non slip anti r9 r10 r11 large format bullnose pencil listello trim pave crazy the and').split(' ').forEach(function (w) { STOP[w] = 1; });
  // The Colour metafield is only a coarse base colour (Army Green & Mint Green both = "Green"),
  // so derive the specific colour from the title instead, e.g. "Army Green", "Dark Red Terracotta".
  function colourInfo(title) {
    var t = String(title || '').toLowerCase().replace(/\d+(?:\.\d+)?\s*(?:mm|cm)?/g, ' ').replace(/[x×]/g, ' ').replace(/\bdiameter\b/g, ' ');
    var words = t.split(/[^a-z]+/).filter(Boolean), phrase = [];
    for (var i = 1; i < words.length; i++) { var w = words[i]; if (STOP[w]) { if (phrase.length) break; else continue; } phrase.push(w); if (phrase.length >= 4) break; }
    return { name: phrase.map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' '), key: phrase.join(' ') };
  }
  // Canonical size key so "60mm x 250mm" and "60x250mm" dedupe to one size.
  function sizeKeyOf(raw) {
    var s = String(raw || '');
    if (/crazy\s*pave/i.test(s)) return 'crazypave';
    if (/diameter/i.test(s)) { var d = s.match(/\d+(?:\.\d+)?/); return d ? 'dia' + d[0] : ''; }
    var n = s.match(/\d+(?:\.\d+)?/g);
    if (n && n.length) return n.slice(0, 2).map(Number).sort(function (a, b) { return a - b; }).join('x');
    return s.toLowerCase().replace(/\s+/g, '');
  }
  // Compact label that fits inside the shape box: "250×400", "Ø19", "Crazy pave".
  function compactSize(raw) {
    var s = String(raw || '');
    if (/crazy\s*pave/i.test(s)) return 'Crazy pave';
    if (/diameter/i.test(s)) { var d = s.match(/\d+(?:\.\d+)?/); return d ? 'Ø' + d[0] : s; }
    var n = s.match(/\d+(?:\.\d+)?/g);
    if (n && n.length >= 2) return n[0] + '×' + n[1];
    if (n && n.length === 1) return n[0] + 'mm';
    return s;
  }

  function buildIndex(items) {
    // group by first word
    var raw = {};
    items.forEach(function (p) { var s = seriesKey(p.t); (raw[s] = raw[s] || []).push(p); });
    // prefix-merge (shorter key that is a prefix of a longer one, len>=4)
    var keys = Object.keys(raw).sort(function (a, b) { return a.length - b.length; });
    var merged = {};
    keys.forEach(function (k) {
      var tgt = k;
      for (var i = 0; i < Object.keys(merged).length; i++) { var kk = Object.keys(merged)[i]; if (kk.length >= 4 && k.indexOf(kk) === 0) { tgt = kk; break; } }
      merged[tgt] = (merged[tgt] || []).concat(raw[k]);
    });
    var ranges = [], byHandle = {};
    Object.keys(merged).forEach(function (k) {
      var arr = merged[k];
      var i = ranges.length;
      // Include singletons too so EVERY product shows at least its own colour swatch.
      var products = arr.map(function (p) {
        var ci = colourInfo(p.t);
        var mf = firstVal(p.c);
        var cname = ci.name || mf;
        var ckey = (ci.key || mf.toLowerCase()).replace(/\s+/g, ' ').trim();
        var rawSize = firstVal(p.s) || firstVal(p.l);
        return { handle: p.h, colour: cname, colourKey: ckey, label: cname, size: rawSize, sizeKey: sizeKeyOf(rawSize), title: p.t || '', image: p.img || '', big: p.big || '', m2: p.m2 || 0, px: p.px || 0 };
      });
      ranges.push({ products: products });
      products.forEach(function (pr) { byHandle[pr.handle] = i; });
    });
    return { ranges: ranges, byHandle: byHandle };
  }

  function fetchData() {
    return fetch(DATA_URL + '&page=1').then(function (r) { return r.json(); }).then(function (d) {
      var items = d.items || [];
      var pages = d.pages || 1;
      if (pages <= 1) return items;
      var reqs = [];
      for (var p = 2; p <= pages; p++) reqs.push(fetch(DATA_URL + '&page=' + p).then(function (r) { return r.json(); }).then(function (dd) { return dd.items || []; }).catch(function () { return []; }));
      return Promise.all(reqs).then(function (rest) { return items.concat.apply(items, rest); });
    });
  }

  var idxPromise = null;
  function getIndex() {
    if (idxPromise) return idxPromise;
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && (Date.now() - cached.t) < TTL && cached.idx) { idxPromise = Promise.resolve(cached.idx); return idxPromise; }
    } catch (e) {}
    idxPromise = fetchData().then(function (items) {
      var idx = buildIndex(items);
      try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), idx: idx })); } catch (e) {}
      return idx;
    }).catch(function () { return null; });
    return idxPromise;
  }

  function chip(p, active, link) {
    var hex = hexOf(p.colour);
    var inner = hex ? '<span class="rsw__dot" style="background:' + hex + '"></span>'
                    : '<span class="rsw__dot rsw__dot--img"' + (p.image ? ' style="background-image:url(' + esc(thumb(p.image, 60)) + ')"' : '') + '></span>';
    var cls = 'rsw__chip' + (active ? ' is-active' : '');
    var title = esc(p.label || p.colour || 'View');
    if (link === false) return '<span class="' + cls + '" title="' + title + '">' + inner + '</span>';
    return '<a class="' + cls + '" href="' + purl(p.handle) + '" title="' + title + '" aria-label="' + title + '">' + inner + '</a>';
  }

  function colourChips(colours, self, pick) {
    var multi = colours.length > 1;
    var h = '<div class="rsw__chips">';
    colours.forEach(function (c) { var t = pick(c.colourKey) || c; h += chip(t, c.colourKey === self.colourKey, multi); });
    return h + '</div>';
  }
  // Tile-shape outline graphic from a size string (kit-kat sticks, brick, square,
  // penny circle, hexagon, crazy pave). Pure, ES5, never throws. Colour via currentColor.
  function shapeGraphic(sizeStr, title) {
    var MAX = 34;            // longer side normalises to this
    var CX = 22, CY = 22;    // centre of 44x44
    var s = String(sizeStr == null ? '' : sizeStr);
    var t = String(title == null ? '' : title).toLowerCase();

    function open(strokeW) {
      return "<svg viewBox='0 0 44 44' width='100%' height='100%' fill='none'" +
             " stroke='currentColor' stroke-width='" + (strokeW || 1.6) + "' stroke-linejoin='round'" +
             " stroke-linecap='round'>";
    }
    function n(v) { return Math.round(v * 100) / 100; }
    function parseDims(str) {
      var nums = [], re = /(\d+(?:\.\d+)?)/g, m;
      while ((m = re.exec(str)) !== null) { nums.push(parseFloat(m[1])); }
      return nums;
    }
    function circle() {
      var r = MAX / 2;
      return open() + "<circle cx='" + CX + "' cy='" + CY + "' r='" + n(r) + "'/></svg>";
    }
    function hexagon() {
      var r = MAX / 2, pts = [];
      for (var i = 0; i < 6; i++) {
        var a = (Math.PI / 180) * (60 * i - 90);
        pts.push(n(CX + r * Math.cos(a)) + ',' + n(CY + r * Math.sin(a)));
      }
      return open() + "<polygon points='" + pts.join(' ') + "'/></svg>";
    }
    function rrect(longSide, shortSide, radius) {
      var w, h;
      if (longSide >= shortSide) { w = MAX; h = Math.max(5, MAX * (shortSide / longSide)); }
      else { h = MAX; w = Math.max(5, MAX * (longSide / shortSide)); }
      var x = CX - w / 2, y = CY - h / 2;
      var rad = radius == null ? Math.min(3, Math.min(w, h) / 2) : radius;
      return open() + "<rect x='" + n(x) + "' y='" + n(y) + "' width='" + n(w) +
        "' height='" + n(h) + "' rx='" + n(rad) + "' ry='" + n(rad) + "'/></svg>";
    }
    function square() {
      var side = MAX, x = CX - side / 2, y = CY - side / 2;
      return open() + "<rect x='" + n(x) + "' y='" + n(y) + "' width='" + n(side) +
        "' height='" + n(side) + "' rx='2' ry='2'/></svg>";
    }
    function sticks(longSide, shortSide) {
      // Stick width comes from the REAL width in mm, not the long:short ratio.
      // A 47.5x304 finger and a 22.5x151.5 kit kat have almost the same ratio, so a
      // ratio-only icon drew them identically and the two chips on the Hatsu page
      // were indistinguishable. Now a wider stick means fewer, fatter bars.
      // (Charbel, 2026-09-30.)
      var stickH = MAX, avail = MAX;
      var stickW = Math.max(1.8, Math.min(9, MAX * (shortSide / 150)));
      var gap = stickW >= 7 ? 3.5 : 2;
      var count = Math.max(3, Math.min(9, Math.floor((avail + gap) / (stickW + gap))));
      var groupW = count * stickW + (count - 1) * gap;
      if (groupW > avail) { stickW = (avail - (count - 1) * gap) / count; groupW = avail; }
      var startX = CX - groupW / 2, y = CY - stickH / 2;
      var rad = Math.min(stickW / 2, 2), out = open(stickW < 4 ? 1.2 : 1.6);
      for (var i = 0; i < count; i++) {
        var x = startX + i * (stickW + gap);
        out += "<rect x='" + n(x) + "' y='" + n(y) + "' width='" + n(stickW) +
          "' height='" + n(stickH) + "' rx='" + n(rad) + "' ry='" + n(rad) + "'/>";
      }
      return out + "</svg>";
    }
    function crazy() {
      var out = open();
      var polys = ['6,10 18,7 22,16 14,22 6,19', '22,16 18,7 31,8 37,15 30,21', '6,19 14,22 15,32 8,38 6,30', '14,22 30,21 32,30 22,38 15,32', '30,21 37,15 38,26 32,30'];
      for (var i = 0; i < polys.length; i++) { out += "<polygon points='" + polys[i] + "'/>"; }
      return out + "</svg>";
    }
    try {
      if (/diameter/i.test(s)) { return circle(); }
      if (/crazy\s*pave/i.test(s)) { return crazy(); }
      var dims = parseDims(s);
      if (dims.length < 1) { return crazy(); }
      if (/hexagon|hex\b/.test(t)) { return hexagon(); }
      if (dims.length === 1) {
        if (/\bpenny\b|\bround\b/.test(t)) { return circle(); }
        return square();
      }
      var a = dims[0], b = dims[1];
      if (!(a > 0) || !(b > 0)) { return square(); }
      var longS = Math.max(a, b), shortS = Math.min(a, b);
      var r = longS / shortS;
      if (/\bpenny\b|\bround\b/.test(t) && longS <= 60) { return circle(); }
      if (r < 1.25) { return square(); }
      if (r < 2.2) { return rrect(longS, shortS, 2); }
      if (r < 4) { return rrect(longS, shortS, 4); }
      if (shortS <= 50) { return sticks(longS, shortS); }
      return rrect(longS, shortS, 4);
    } catch (e) { return square(); }
  }

  // Size/format options rendered as tile-shape outline graphics (product page only).
  function sizeChips(sizes, self, pick) {
    var h = '<div class="rsw__chips rsw__chips--shape">';
    sizes.forEach(function (sz) {
      var t = pick(sz.sizeKey) || sz;
      var active = sz.sizeKey === self.sizeKey ? ' is-active' : '';
      h += '<a class="rsw__shape' + active + '" href="' + purl(t.handle) + '" title="' + esc(sz.size) + '" aria-label="' + esc(sz.size) + '">' +
        '<span class="rsw__shape-ico">' + shapeGraphic(sz.size, t.title || '') + '</span>' +
        '<span class="rsw__shape-dim">' + esc(compactSize(sz.size)) + '</span></a>';
    });
    return h + '</div>';
  }

  function money(cents) {
    var v = (parseFloat(cents) || 0) / 100;
    var f = (window.theme && window.theme.moneyFormat) || '$AMOUNT';
    if (f.indexOf('{{') === -1) return '$' + v.toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  }
  // In-place colourway swap on catalogue cards: tap a swatch -> the card becomes that
  // colourway (image, title, links, price); tapping the card then opens that product.
  function swapCard(card, p) {
    card.setAttribute('data-handle', p.handle);
    var media = card.querySelector('.product-card__media');
    if (media) { media.setAttribute('href', purl(p.handle)); media.setAttribute('aria-label', p.title); }
    var img = media && media.querySelector('img');
    if (img && (p.big || p.image)) { img.src = p.big || thumb(p.image, 700); img.alt = p.title; }
    var titleLink = card.querySelector('.product-card__info > a');
    if (titleLink) titleLink.setAttribute('href', purl(p.handle));
    var title = card.querySelector('.product-card__title');
    if (title) title.textContent = p.title;
    var sample = card.querySelector('[data-sample-add]');
    if (sample) sample.setAttribute('data-sample-of', p.title);
    var price = card.querySelector('.product-card__price');
    if (price) {
      if (p.m2 > 0) {
        price.innerHTML = '<span class="product-card__price-m2">' + money(p.m2 * 100) + '<span class="product-card__price-unit">/m&sup2;</span></span>' +
          '<span class="product-card__price-box">' + money(p.px) + ' per box</span>';
      } else if (p.px > 0) {
        price.innerHTML = '<span class="product-card__price-m2">' + money(p.px) + '</span>';
      }
    }
    var rvw = card.querySelector('[data-review-badge]');
    if (rvw) {
      rvw.setAttribute('data-handle', p.handle);
      rvw.setAttribute('data-title', p.title);
      rvw.setAttribute('href', purl(p.handle) + '#reviews');
      rvw.removeAttribute('data-rvw-done');
      if (window.theme && window.theme.renderReviews) window.theme.renderReviews();
    }
    var sw = card.querySelector('[data-range-swatches]');
    if (sw) { sw.setAttribute('data-handle', p.handle); sw.removeAttribute('data-rsw-done'); }
  }
  document.addEventListener('click', function (e) {
    var chipEl = e.target.closest('.rsw__chip[href]');
    if (!chipEl) return;
    var card = e.target.closest('[data-product-card]');
    if (!card) return; // product-page swatches keep navigating
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    var handle = chipEl.getAttribute('href').replace('/products/', '');
    getIndex().then(function (index) {
      if (!index || index.byHandle[handle] == null) { window.location.href = chipEl.getAttribute('href'); return; }
      var products = index.ranges[index.byHandle[handle]].products;
      var p = products.filter(function (x) { return x.handle === handle; })[0];
      if (!p) { window.location.href = chipEl.getAttribute('href'); return; }
      swapCard(card, p);
      var swEl = card.querySelector('[data-range-swatches]');
      if (swEl) { try { build(swEl, index); swEl.setAttribute('data-rsw-done', '1'); } catch (err) {} }
    });
  });

  function build(el, index) {
    var handle = el.getAttribute('data-handle');
    var ctx = el.getAttribute('data-context') || 'card';
    var ri = index.byHandle[handle];
    if (ri == null) return;
    var products = index.ranges[ri].products;
    if (!products || !products.length) return;
    var self = products.filter(function (p) { return p.handle === handle; })[0] || products[0];

    // COLOURS are restricted to the product's own sub-range: only colourways that exist in
    // this exact size/format (so Hatsuborder never shows Hatsu Square or Long Brick colours).
    // SIZES still span the whole family, so format switching keeps working.
    var sameFormat = products.filter(function (p) { return p.sizeKey === self.sizeKey; });
    var colours = uniqueBy(sameFormat, 'colourKey');
    var sizes = uniqueBy(products, 'sizeKey');     // unique sizes (60mm x 250mm == 60x250mm)

    function pickColour(ckey) { return sameFormat.filter(function (p) { return p.colourKey === ckey; })[0]; }
    function pickSize(skey) { return products.filter(function (p) { return p.sizeKey === skey && p.colourKey === self.colourKey; })[0] || products.filter(function (p) { return p.sizeKey === skey; })[0]; }

    var html = '';
    // COLOUR — every product shows a colour swatch (its own if it's the only one).
    if (colours.length) {
      html += '<div class="rsw rsw--colour">';
      if (ctx === 'pdp') html += '<div class="rsw__label">Colour: <strong>' + esc(self.colour) + '</strong>' + (colours.length > 1 ? ' <span class="rsw__count">' + colours.length + ' colours</span>' : '') + '</div>';
      html += colourChips(colours, self, pickColour);
      html += '</div>';
    }
    // SIZE / FORMAT — product page ONLY (never on catalogue/search cards), and only when
    // the range comes in more than one size. Rendered as tile-shape outline graphics.
    if (ctx === 'pdp' && sizes.length > 1) {
      html += '<div class="rsw rsw--size">';
      html += '<div class="rsw__label">Size / format: <strong>' + esc(compactSize(self.size)) + '</strong></div>';
      html += sizeChips(sizes, self, pickSize);
      html += '</div>';
    }
    if (html) el.innerHTML = html;
  }

  function run() {
    var nodes = document.querySelectorAll('[data-range-swatches][data-handle]');
    if (!nodes.length) return;
    getIndex().then(function (index) {
      if (!index || !index.byHandle) return;
      nodes.forEach(function (el) { if (el.getAttribute('data-rsw-done')) return; try { build(el, index); el.setAttribute('data-rsw-done', '1'); } catch (e) {} });
    });
  }

  window.theme = window.theme || {};
  window.theme.renderRangeSwatches = function () {
    document.querySelectorAll('[data-range-swatches][data-rsw-done]').forEach(function (el) { el.removeAttribute('data-rsw-done'); });
    run();
  };

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
